import { render, staticRenderFns } from "./OrderCard.vue?vue&type=template&id=45f3807b&scoped=true&"
import script from "./OrderCard.vue?vue&type=script&lang=js&"
export * from "./OrderCard.vue?vue&type=script&lang=js&"
import style0 from "./OrderCard.vue?vue&type=style&index=0&id=45f3807b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45f3807b",
  null
  
)

export default component.exports